import { render, staticRenderFns } from "./RefereeColumn.vue?vue&type=template&id=abf9a2a4&"
import script from "./RefereeColumn.vue?vue&type=script&lang=js&"
export * from "./RefereeColumn.vue?vue&type=script&lang=js&"
import style0 from "./RefereeColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports